export class GetLenderUser {
	static readonly type = '[LenderUser] GetLenderUser';
	constructor() {}
}

export class UpdateLenderUser {
	static readonly type = '[LenderUser] UpdateLenderUser';
	constructor(public userId: number, public settings: {} ) {}
}

export class GoOnline {
	static readonly type = '[LenderUser] GoOnline';
	constructor(public userId: number ) {}
}

export class GoOffline {
	static readonly type = '[LenderUser] GoOffline';
	constructor(public userId: number ) {}
}

export class GoOnlineSubscription {
  static readonly type = '[LenderUser] GoOnlineSubscription';
  constructor(public userId: number ) {}
}

export class GoOfflineSubscription {
  static readonly type = '[LenderUser] GoOfflineSubscription';
  constructor(public userId: number ) {}
}

export class UpdatePausedWorkflow {
	static readonly type = '[LenderUser] UpdatePausedWorkflow';
	constructor(public userId: number, public meta: {}) {}
}

export class TogglePermission {
  static readonly type = '[LenderUser] TogglePermission';
  constructor(
    public permission: string,
  ) {}
}


